<template lang="pug">
.themenu(v-shortcuts="[{ shortcut: [ 'f9', ], callback: shortcuts, push: true, focus: true },]")
  modal-shortcuts
  .nav-bar
    .logo-header
      router-link(to='/')
        img.navbar-logo(alt="Vue logo" src="../assets/pma_menu.svg")
    vm-collapse(accordion)
      vm-collapse-item(index="0" v-for="(item, i) in menuItems.menu" :key="i")
        div(slot="header")
          unicon(:name="item.icon" fill="white")
          div.item-name {{ $t(item.name )}}
        ul
          li(v-for="(subitem, i) in menuItems.submenu" :key="i" v-if="subitem.parent === item.parent")
            vm-button(v-if="subitem.style === 'primary'" icon="plus" color="secondary" @click="$router.push(subitem.link)") {{ $t(subitem.name) }}
            .item(v-else)
              vm-button.help(type="flat" color="rgba(0, 0, 0, 0.2)" text-color="#fff" :icon="subitem.icon" @click="$router.push(subitem.link)") {{ $t(subitem.name) }}
      .bottom-menu
        vm-button.help(type="flat" color="#fff" text-color="#000" @click="logout")
          vm-icon(icon="log-out-outline" size="1.4rem" color="#fff")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
const ModalShortcuts = () => import('@/components/aditionals/ModalShortcuts.vue')

export default {
  name: 'TheMenu',
  components: {
    ModalShortcuts
  },
  data: () => ({
    activeItem: 0
  }),
  computed: {
    ...mapGetters([
      'menuItems'
    ])
  },
  methods: {
    ...mapActions([
      'setModalShortcutsVisible'
    ]),
    logout () {
      this.$auth.logout({
        makeRequest: true,
        redirect: { name: 'login' }
      })
    },
    shortcuts () {
      this.setModalShortcutsVisible(true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.themenu {
  overflow: hidden;
  height: 100%;
  display: flex;
  width: 65px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  background: black;
  transition: width 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
  .vm-collapse-item--icon-header {
    display: none;
  }
  .item-name {
    display: none !important;
  }
  .logo-header {
    margin: 15px 0px 10px 0px;
    text-align: center;
  }
  .nav-bar {
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    margin: 2px;
    background-color: --primary;
    .vm-collapse {
      padding: 0;
      margin-left: 6px;
    }
    .open-item {
      .vm-collapse-item--header {
        background: rgba(var(--primary),1);
        color: #FFF;
      }
    }
    .vm-collapse-item {
      color: #FFF;
      &:hover {
        color: rgba(var(--primary),1);
      }
      .vm-collapse-item--header {
        div {
          display: flex;
          .unicon {
            margin-right: 10px;
          }
        }
      }
    }
    ul {
      list-style: none; /* Eliminamos los bullets */
      padding-top: 10px; /* Quitamos el padding */
      li {
        display: flex;
        .item {
          display: flex;
          margin-top: 10px;
          align-items: center;
          border-radius: 7px;
          cursor: pointer;
          .unicon {
            margin: 5px;
          }
          .isActive {
            background: #444  !important;
          }
        }
      }
    }
  }
}

.vm-collapse-item--header {
  &:hover {
    background: rgba(var(--primary),1);
    color: #FFF;
  }
}
.bottom-menu {
  position: absolute;
  left: 5px;
  text-align: center;
}
.navbar-logo {
  height: 50px;
}
.themenu:hover {
  width: 200px;
  .nav-bar {
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .vm-collapse {
    margin-left: 0px;
  }
  .vm-collapse-item--icon-header {
    display: block;
  }
  .item-name {
    display: block !important;
  }
  .sub-nabar {
    width: 200px;
    .vm-navbar--item {
      a div span {
        opacity: 1;
      }
    }
  }
  .navbar-logo {
    height: 90px;
  }
  .bottom-menu {
    position: absolute;
    left: -1px;
    text-align: left;
  }
}
.help {
  .vm-icon {
    margin-right: 20px !important;
  }
  &:hover {
    font-size: 16px;
    color: rgba(var(--primary),1) !important;
  }
}
</style>
